"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "palena": {
    "a7b97eda": [{
      "hkey": "37ae8449",
      "slug": "palena",
      "name": "Palena",
      "primary": true,
      "skipSearch": false
    }],
    "aia-dei-cordoni": [{
      "hkey": "37ae8449",
      "slug": "palena",
      "name": "Palena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fcff00b2": [{
      "hkey": "37ae8449",
      "slug": "palena",
      "name": "Palena",
      "primary": true,
      "skipSearch": false
    }],
    "palena-stazione": [{
      "hkey": "37ae8449",
      "slug": "palena",
      "name": "Palena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;